const PKCE_VERIFIER_BYTE_LENGTH = 32;
const PKCE_CODE_CHALLENGE_METHOD = 'S256';

const getWebCrypto = () => {
  if (typeof window !== 'undefined' && window.crypto) {
    return window.crypto;
  }

  if (typeof crypto !== 'undefined') {
    return crypto;
  }

  throw new Error('Web Crypto API is not available in this environment.');
};

const bytesToBase64 = (bytes) => {
  if (typeof btoa === 'function') {
    return btoa(String.fromCharCode(...bytes));
  }

  throw new Error('Base64 encoding is not available in this environment.');
};

const toBase64Url = (bytes) => bytesToBase64(bytes).
  replace(/\+/g, '-').
  replace(/\//g, '_').
  replace(new RegExp('=+$'), '');

const generatePkceCodeVerifier = () => {
  const verifierBytes = new Uint8Array(PKCE_VERIFIER_BYTE_LENGTH);
  getWebCrypto().getRandomValues(verifierBytes);

  return toBase64Url(verifierBytes);
};

const generatePkceCodeChallenge = async (codeVerifier) => {
  const verifierAsBytes = new TextEncoder().encode(codeVerifier);
  const digest = await getWebCrypto().subtle.digest('SHA-256', verifierAsBytes);

  return toBase64Url(new Uint8Array(digest));
};

export const generatePkceCodePair = async () => {
  const codeVerifier = generatePkceCodeVerifier();
  const codeChallenge = await generatePkceCodeChallenge(codeVerifier);

  return {
    codeVerifier,
    codeChallenge,
    codeChallengeMethod: PKCE_CODE_CHALLENGE_METHOD,
  };
};